
export const YOUTUBE_API_KEY = 'AIzaSyDatNhLrI7xcUoYX9pPXHJKvzeAfYBO5cA'
export const SOCCER_API_KEY = '515c6488f516424d97ce5b2c4090d286'
export const API_BASE_URL = 'https://futzone.herokuapp.com'



// WEBPACK FOOTER //
// ./src/config.js